import { useState } from "react";

import {
  fileFormat,
  errorMessages,
  inboxPageConstants,
  toastTypes,
} from "../../../constants";
import { createNewGuid, customToast } from "../../../../../shared";

const { DEFAULT_FILE_SIZE_IN_BYTES } = inboxPageConstants;

/**
 * Manages inbox chat file selection, validation, and base64 conversion.
 */
const useInboxFileUploads = () => {
  const [files, setFiles] = useState([]);

  const handleFileChange = (event) => {
    const filesArray = Array.from(event.target.files);
    const updatedFiles = [...files];
    const promises = [];

    for (const file of filesArray) {
      if (!fileFormat.BASE_64_IMAGE_TYPES.includes(file.type)) {
        customToast(errorMessages.INVALID_FILE_TYPE, toastTypes.ERROR);
        return;
      }
      if (file.size <= DEFAULT_FILE_SIZE_IN_BYTES) {
        const reader = new FileReader();

        //Create a promise to handle the async file read
        const readFilePromise = new Promise((resolve) => {
          reader.onload = (loadEvent) => {
            const result = loadEvent.target.result;

            updatedFiles.push({
              attachment: result,
              contentType: file.type,
              id: createNewGuid(),
            });

            resolve();
          };
        });

        promises.push(readFilePromise);
        reader.readAsDataURL(file);
      } else {
        customToast(errorMessages.IMAGE_SIZE_EXCEED, toastTypes.ERROR);
      }
    }

    //Once all files are processed, update the state
    Promise.all(promises).then(() => {
      setFiles(updatedFiles);
    });
  };

  return { files, setFiles, handleFileChange };
};

export default useInboxFileUploads;
